import React, { Component } from 'react'
import { connect } from 'react-redux'

//import T from '../../../translate/T'
import Footer from './../../../../src/SPRINTA/Footer';
import { Container, ContainerFluid, Row, Col } from './../../../../src/SPRINTA/atoms/Grid';
import Button from './../../../../src/SPRINTA/atoms/Button';
import CoverImage from './../../../../src/SPRINTA/atoms/CoverImage';
import './../effects.css';
import Plx from 'react-plx';

import style from './style.css';

const headerparallax2 = [
  {
    start: 0,
    duration: 2500,
    properties: [
      {
        startValue: 0,
        endValue: 490,
        property: "translateY"
      }
    ]
  }
]

class Home extends Component {
  constructor() {
    super();
    this.state = {
       className: 'hidden',
       marcador1:'hidden',
       marcador2:'hidden',
       marcador3:'hidden',
       confirmados:'hidden',
       pc:'hidden',
       boxVideo: false

    }
  }

  handleScroll() {
    //console.log(document.documentElement.scrollTop);
    var className = 'animated fadeInLeft'
    if (document.documentElement.scrollTop > 2100 && this.state.className !== className){
      this.setState({
        className: className
      })
    }

    var marcador1 = 'marcador1 animated fadeIn';
    var marcador2 = 'marcador2 animated fadeIn';
    var marcador3 = 'marcador3 animated fadeIn';
    var confirmados = 'confirmados animated fadeIn';
    var pc = 'animated fadeIn';
    if (document.documentElement.scrollTop > 800 && this.state.marcador1 !== marcador1){
      setTimeout(function(){
        this.setState({
          marcador1: marcador1
        })
      }.bind(this), 800);
      setTimeout(function(){
        this.setState({
          marcador2: marcador2
        })
      }.bind(this), 1500);
      setTimeout(function(){
        this.setState({
          marcador3: marcador3
        })
      }.bind(this), 2500);
      setTimeout(function(){
        this.setState({
          confirmados: confirmados
        })
      }.bind(this), 500);
      setTimeout(function(){
        this.setState({
          pc: pc
        })
      }.bind(this), 0);
    }
  }

  componentDidMount() {
    window.onscroll = () => this.handleScroll()
  }

  scrollToVideo() {
    var to			= 500;
    var duration	= 300;
    var element 	= window;

    element.scrollTop = 1200

    var start = window.document.documentElement.scrollTop,
      change  = to - start,
      currentTime = 0,
      increment	  = 20;

    var easeInOutQuad = function (t, b, c, d) {
      t /= d/2;
      if (t < 1) return c/2*t*t + b;
      t--;
      return -c/2 * (t*(t-2) - 1) + b;
    }

    var animateScroll = function(){
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTo(0, val);
      if(currentTime < duration) {
          setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }

  render() {
    return (
      <div>
        <ContainerFluid>
          <Row style={{ overflow: 'hidden' }}>
            <Col size="12" style={{paddingLeft: '0',paddingRight: '0'}}>
              <Plx
              parallaxData={ headerparallax2 }
              >
                <CoverImage className={style.instheader} image={require('./background.jpg')}>
                  <Container>
                    <h1>Apaixonadamente<br />loucos por esporte</h1>
                    <p>Uma comunidade de atletas, organizadores e<br/>marcas com afinidades em comum.</p>
                    <Button onClick={() => {
                      this.setState({ boxVideo: true })
                      this.scrollToVideo()
                   }} inline theme='primary'>Assista o vídeo</Button>
                  </Container>
                </CoverImage>
              </Plx>
            </Col>

            <div className={`${style['boxVideo']} ${this.state.boxVideo ? style['boxVideo-active'] : null}`}>
              <Col size="12" style={{paddingLeft: '0',paddingRight: '0'}}>
                <iframe title='Vídeo conceito' style={{ marginBottom: '-4px' }} width="100%" height="530" src="https://www.youtube.com/embed/FUVpzxVuwHE" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
              </Col>
            </div>

            <Col size="12" text="center left" style={{paddingLeft: '0',paddingRight: '0'}}>
                <CoverImage className={style.instsports} image={require('./background3.jpg')}>
                  <Container>
                    <h1><b>Atletas, organizadores<br />e marcas</b> com algo em<br />comum: o esporte</h1>
                    <p>Treine, desafie-se, participe de um grupo com atletas com os mesmos<br />interesses que você, viva experiências únicas no esporte que você ama e<br />monte o seu próprio evento.</p>
                  </Container>
                </CoverImage>
            </Col>

            <Col size="12" className={style.instsimplifique} style={{paddingLeft: '0',paddingRight: '0'}}>
              <Container>
                <Row>
                  <Col size="12 6" className={style.instpc}>
                    <div>
                      <img alt="" src={require('./pc.png')} className={this.state.pc}/>

                      <img alt="" src={require('./marcador1.png')} className={this.state.marcador1}/>
                      <img alt="" src={require('./marcador2.png')} className={this.state.marcador2}/>
                      <img alt="" src={require('./marcador3.png')} className={this.state.marcador3}/>
                      <img alt="" src={require('./confirmados.png')} className={this.state.confirmados}/>
                    </div>
                  </Col>
                  <Col size="12 6" text="center left">
                    <h1>Simplifique a<br /><b>organização</b><br />do seu <b>evento</b></h1>
                    <p>Desde a divulgação do evento até a gestão dos atletas, categorais, lotes e cobranças são tarefas automatizadas pela plataforma. Através de um algoritmo inteligente o sistema trabalha para cuidar de toda a parte burocrática, deixando o organizador livre para focar em outras tarefas da organização.</p>
                    <a href='/conheca/eventos'>
                       <Button inline theme="light">Saiba mais</Button>
                    </a>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col size="12" style={{paddingLeft: '0',paddingRight: '0'}}>
              <CoverImage className={style.instcontent} image={require('./contentbg.jpg')}>
                <Container>
                  <Row>
                     <Col size="12 6" float="center right">
                      <div style={{textAlign:'center'}}>
                        <img alt="" src={require('./cel.png')}/>
                      </div>
                    </Col>

                    <Col size="12 6" text="center right" float="center left" className={style.instpublico}>
                      <h1>Desafie seu <b>público</b></h1>
                      <p>Crie desafios e incentive milhares de atletas a superarem seus limites diariamente. Gere uma experiência única entre o atleta e a sua marca.                      </p>
                      <Button inline theme="light">Saiba mais</Button>
                    </Col>


                    <Col size="12" className={style.instmedida}>
                      <h1>Nem muito fácil, nem muito difícil.<br/><b>Na medida certa</b>.</h1>
                      <p>Nada de ficar para trás no treino. Escolha uma experiência e vá treinando<br />para subir de nível! Experiências maiores e desafiadoras ajudarão você a<br />transpor seus limites e ainda fornecer memórias incríveis.</p>
                      <Button inline theme='dark'>Saiba mais</Button>
                    </Col>
                    <Col size="12" className={style.instciclista}>
                      <Row>
                        <Col size="12 6" float='left right' text="center left" className={style.instciclistatext}>
                          <h1>Para <b>grupos</b>,<br /><b>federações</b> e<br /><b>assessorias esportivas</b></h1>
                           <Row>
                              <Col size="11" float="center left">
                                 <p>Uma plataforma completa para gestão do grupo ou assessoria. Tenha organizado seus treinos, eventos, cobranças e atletas. A própria plataforma se encarrega de cobrar as mensalidades dos seus atletas.</p>
                              </Col>
                           </Row>
                           <a href='/conheca/grupos'>
                             <Button inline theme='dark'>Saiba mais</Button>
                           </a>
                        </Col>

                        <Col size="12 6" float='right left' text="center">
                           <div className={this.state.className}>
                             <img alt="" src={require('./ciclista.png')}/>
                           </div>
                        </Col>

                      </Row>
                    </Col>
                  </Row>
                </Container>
              </CoverImage>
            </Col>
            <Col size="12" className={style.instparceiros} style={{paddingLeft: '0',paddingRight: '0'}}>
              <Container>
                <Row>
                  <Col size="12 6" float="right left" text="center right">
                    <h1>A plataforma oficial<br />de grandes parceiros</h1>
                    <h2>+ de 700 eventos parceiros em 2016, distribuídos em 16 estados brasileiros</h2>
                    <p>O SPRINTA é uma plataforma oficial de diversas federações e<br />empresas de todo o Brasil. Seja você também nosso parceiro.</p>
                  </Col>
                  <Col size="12 6" float="left right">
                    <img alt="" src={require('./parceiros.jpg')}/>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </ContainerFluid>
        <Footer lang="pt-BR" />
      </div>
    )
  }
}

const mapStateToProps = store => ({})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Home)



// WEBPACK FOOTER //
// ./src/App/pages/Home/index.js